import { IObjectTranslatable, HtmlColorCodeTranslator } from ".";
import { ILineItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, LineItem } from "../../../../domain/document/items";

import {
  Point,
  LineStyle,
  Color,
  Vector,
} from "../../../../domain/drawing";

export class LineItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as ILineItemBean;
    const result = new LineItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = !!bean.isAdditional || !!bean.isLineEditable; // 基本的には追加オブジェクトのみ編集可能だが、フォーマット編集の設定で編集可能な矢印を置くこともできる
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.vector = new Vector(new Point(bean.lineStartX, bean.lineStartY), new Point(bean.lineEndX, bean.lineEndY));
    result.lineStyle = new LineStyle(new Color(bean.color), bean.state, bean.thickness);
    result.arrowKind = bean.arrowState;
    return result;
  }

  toBean(item: IItem): ILineItemBean {
    const target = item as LineItem;
    return {
      type: BeanTypes.Line,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      lineStartX: Math.floor(target.vector.from.x),
      lineStartY: Math.floor(target.vector.from.y),
      lineEndX: Math.floor(target.vector.to.x),
      lineEndY: Math.floor(target.vector.to.y),
      color: HtmlColorCodeTranslator.fromColor(target.lineStyle.color),
      state: target.lineStyle.kind,
      thickness: target.lineStyle.width,
      arrowState: target.arrowKind,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      isLineEditable: target.isEditable,  // 返却不要
    };
  }
}
